/* eslint-disable */
// /src/services/meterAccountsService.js
import {
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    where,
} from "firebase/firestore";
import { ensureFirebase, db } from "./firebase";

ensureFirebase();

const COL = collection(db, "meter_accounts");

/**
 * 문서 ID로 바로 읽기(필요 시 사용)
 */
export async function getMeterAccount(id) {
    if (!id) return null;
    try {
        const ref = doc(COL, id);
        const snap = await getDoc(ref);
        if (!snap.exists()) return null;
        return { id: snap.id, ...(snap.data() || {}) };
    } catch (e) {
        console.warn("[getMeterAccount] error:", e?.message || e);
        return null;
    }
}

/**
 * accountId 필드로 조회 (계정 이름 기준)
 * - meter_accounts 컬렉션에서 accountId==username 인 문서 한 개 찾기
 */
export async function getMeterAccountByAccountId(accountId) {
    if (!accountId) return null;
    try {
        const qy = query(COL, where("accountId", "==", accountId));
        const snap = await getDocs(qy);
        if (snap.empty) return null;
        const docSnap = snap.docs[0];
        return { id: docSnap.id, ...(docSnap.data() || {}) };
    } catch (e) {
        console.warn("[getMeterAccountByAccountId] error:", e?.message || e);
        return null;
    }
}
